import { Pinia, Store, getActivePinia } from "pinia"

interface ExtendedPinia extends Pinia {
  _s: Map<string, Store>;
}

/**
 * Esta função reseta as stores que forem passadas em sua chamada, exemplo:
 * const resetarStore = usarLimpadorDeStore()
 * resetarStore.autenticacao() // reseta a store de autenticação
 * ou
 * resetarStore.all() // reseta todas as stores
 */
export const usarLimpadorDeStore = () => {
  const pinia = getActivePinia() as ExtendedPinia

  if (!pinia) {
    throw new Error('Não há instância ativa do Pinia')
  }

  const storesResetadas: Record<string, () => void> = {}

  pinia._s.forEach((store, nome) => {
    storesResetadas[nome] = (): void => store.$reset()
  })

  storesResetadas.todasAsStores = (): void => pinia._s.forEach((store) => store.$reset())

  return storesResetadas
}
